import React, { Fragment } from 'react'
import { connect } from 'react-redux';
import ImageGridUpload from './ImageGridUpload';
import Modal from './Modal';
import $ from 'jquery';
import { gerarHashForString } from '../../util/stringUtil';
import { tamanhoArquivoUpload, LIMITE_UPLOAD_ARQUIVO_ENCOMENDA } from '../../util/applicationContext';
import salvarImagensEncomenda from '../../actions/encomenda/salvarImagensEncomenda';
import { showSuccessMsg } from '../../util/messagesUtil';

export class ModalImagensEncomenda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImg: null,
      mensagens: []
    }
  }

  exibirImagem() {
    return (
      <>
        {this.props.arquivos.map((arq, index) => (
          <Fragment key={`file-${index}`}>
            <ImageGridUpload key={`file-${index}`} setSelectedImg={this.setSelectedImg.bind(this)} file={arq} removerImagem={this.removerImagem.bind(this)} />
          </Fragment>
        ))}
        {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}
      </>
    );
  }

  setSelectedImg(selectedImg) {
    this.setState({ selectedImg })
  }

  removerImagem(arquivo) {
    this.props.removerImagem(arquivo);
  }

  montarParametros() {
    return {
      imagens: this.props.arquivos
    }
  }

  salvar(e) {
    e.preventDefault();
    this.props.salvarImagensEncomenda(this.props.encomenda.id, this.props.encomenda.idEmpresa, this.montarParametros())
      .then(() => {
        this.fecharModal();
        showSuccessMsg('Imagens salvas com sucesso!')
        this.props.buscarEncomendas();
      });
  }

  fecharModal() {
    $('#modalImagensEncomenda').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    this.limparFormulario();
  }

  limparFormulario() {
    this.props.limparImagens();
  }

  handleChangeImagens(event) {

    const chooseFiles = Array.prototype.slice.call(event.target.files);

    const arquivos = [...this.props.arquivos];

    const mensagens = [];

    const mensagem = {
      tipo: 'erro',
      nomeArquivo: '',
      texto: 'Limite excedido de arquivos para upload.'
    };

    if (chooseFiles.length > LIMITE_UPLOAD_ARQUIVO_ENCOMENDA) {
      mensagem.nomeArquivo = chooseFiles[chooseFiles.length - 1].name;
      mensagens.push(mensagem);
      this.setState({ mensagens });
      return;
    }

    const limite = arquivos.length + chooseFiles.length;

    chooseFiles.forEach(file => {
      if (arquivos.findIndex(arq => arq.nome === file.name) === -1) {
        if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG, PNG ou JPG.'
          };
          mensagens.push(mensagem);
        } else if (limite >= 0 && arquivos.length > LIMITE_UPLOAD_ARQUIVO_ENCOMENDA) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Limite excedido de arquivos para upload.'
          };
          mensagens.push(mensagem);
          return;
        } else if (file.size > tamanhoArquivoUpload) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Tamanho do arquivo excede 20 MB.'
          };
          mensagens.push(mensagem);
        } else {
          this.converterParaBase64(file);
        }
      }
    })

    this.setState({ mensagens });
  }

  converterParaBase64(file) {
    const obj = {
      hash: gerarHashForString(`${file.name}`),
      nome: file.name,
      base64ImagemEncomenda: null,
      urlImagem: null,
    };

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const arquivos = [...this.props.arquivos];
      obj.base64ImagemEncomenda = reader.result;
      obj.urlImagem = reader.result;
      arquivos.push(obj);

      this.props.adicionarImagens(arquivos);
    }.bind(this);
    reader.onerror = function () {
      const mensagem = {
        tipo: 'erro',
        nomeArquivo: file.name,
        texto: 'Imagem inválida. Selecione outra imagem.'
      };
      const mensagens = [...this.state.mensagens];
      mensagens.push(mensagem);
      this.setState({ mensagens });
      this.removerImagem(obj);
    }.bind(this);
  }

  recuperaMensagem() {
    return this.state.mensagens.map((mensagem, index) => {
      if (mensagem.tipo === 'sucesso') {
        return (
          <div key={`${mensagem.nomeArquivo}-${index}`} className="alert alert-success col-md-12">
            {mensagem.texto}
            <button type="button" className="close" aria-label="Close"
              onClick={() => {
                this.limparMensagem();
              }
              }>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
        )
      }
      if (mensagem.tipo === 'erro') {
        return (
          <div key={`${mensagem.nomeArquivo}-${index}`} className="alert alert-danger col-md-12">
            {mensagem.texto}
            <button type="button" className="close" aria-label="Close"
              onClick={() => {
                this.limparMensagem();
              }
              }>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
        )
      }
    })
  }

  limparMensagem() {
    this.setState({ mensagens: [] });
  }

  render() {
    return (
      <div className="modal fade show" role="dialog"
        id="modalImagensEncomenda" aria-labelledby="modalImagensEncomenda" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">image</span>
                Imagens — Pedido {this.props.encomenda && this.props.encomenda.idPedido}
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                onClick={() => this.fecharModal()}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="vx-modal-body" style={{ background: '#fff' }}>
              {this.recuperaMensagem()}
              <div className="input-wrapper mt-2">
                <label htmlFor="input-file-encomendas">
                  Adicionar imagens encomenda
                </label>
                <input id="input-file-encomendas" type="file" value="" accept="image/*" onChange={this.handleChangeImagens.bind(this)} multiple />
                <span id="file-name" />
              </div>
              {this.exibirImagem()}
            </div>
            <div className="vx-modal-footer">
              <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                onClick={() => this.fecharModal()}>
                Fechar
              </button>
              <button type="button" className="vx-modal-btn-confirmar"
                onClick={(e) => this.salvar(e)}>
                <span className="material-icons" style={{ fontSize: 15 }}>save</span>
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps(state) {
  return {
    encomenda: state.encomenda
  }
}

export default connect(mapStateToProps, { salvarImagensEncomenda })(ModalImagensEncomenda)